import {
    REGISTER_PUSH_TOKEN
} from './actionTypes';

const registerPushToken = (token, platform) => ({
    type: REGISTER_PUSH_TOKEN,
    payload: {
        token,
        platform
    },
    errors: null
});

export {
    registerPushToken
};
